import { noop } from 'lodash'
import { useParams } from 'react-router'

import {
  useAppRoutes,
  useLocationHelper,
  useProcurifyIntl,
} from '@webapp/hooks'
import {
  type LegalEntityListPageParams,
  LegalEntityListPageTabTypes,
} from '@webapp/platform/legal-entities/pages/types'
import messages from './messages'

interface FeatureSetTab {
  label: string
  to: string
}

/**
 * Orchestration hook for the LegalEntity list FeatureSet.
 *
 * Responsibilities:
 * - URL-based active/inactive tab state
 * - Tab descriptors (label, link) for the <Tabs> chrome
 * - Stub command handlers — replaced when PLAT-4858/4859/4860 wire real flows
 */
export const useLegalEntityListFeatureSet = () => {
  const intl = useProcurifyIntl()
  const { tab } = useParams<LegalEntityListPageParams>()
  const { url } = useAppRoutes()
  const { getQueryString } = useLocationHelper()

  const isActive = tab === LegalEntityListPageTabTypes.ACTIVE

  const tabs: FeatureSetTab[] = [
    {
      label: intl.formatMessage(messages.activeTabLabel),
      to: `${url('LegalEntityListPage', {
        tab: LegalEntityListPageTabTypes.ACTIVE,
      })}${getQueryString({ page: 1 })}`,
    },
    {
      label: intl.formatMessage(messages.inactiveTabLabel),
      to: `${url('LegalEntityListPage', {
        tab: LegalEntityListPageTabTypes.INACTIVE,
      })}${getQueryString({ page: 1 })}`,
    },
  ]

  return {
    state: {
      isActive,
      tabs,
    },
    methods: {
      // TODO(PLAT-4858): open create entity modal.
      onAdd: noop,
      // TODO(PLAT-4858): open edit entity modal.
      onEdit: noop,
      // TODO(PLAT-4859): navigate to entity details page.
      onSelect: noop,
      // TODO(PLAT-4860): deactivate/reactivate flow.
      onDeactivate: noop,
      onActivate: noop,
    },
  }
}
